/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { OrderAttachmentResponse } from '../types/OrderAttachment';

export type OrdersAttachmentsCreateRequest = {} | null | undefined;
export type OrdersAttachmentsCreateResponse = OrderAttachmentResponse;

export type OrdersAttachmentsCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/orders/{id}/attachments/
 *
 * ```yaml
 * operationId: orders_attachments_create
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentUpload'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentUpload'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderAttachment'
 *     description: ''
 * ```
 */
export const ordersAttachmentsCreateOperation = ({ id, ...rest }: OrdersAttachmentsCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/orders/${id}/attachments/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/orders/{id}/attachments/' };
  };

/**
 * POST /dmx-server/orders/{id}/attachments/
 *
 * ```yaml
 * operationId: orders_attachments_create
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentUpload'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentUpload'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderAttachment'
 *     description: ''
 * ```
 */
export const ordersAttachmentsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: OrdersAttachmentsCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<OrderAttachmentResponse>> => {
  const operation = ordersAttachmentsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
